import React, { FC, useState, useEffect } from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import i18n from "src/i18nextConf";

import { Button } from "../../../../../../../components/atoms";

type OwnProps = {
  onSelectBalance: (balance: any) => void;
  isUserInputActive?: boolean;
};

const PreDefBalanceWrapper = styled.div`
  display: flex;
  flex-flow: row wrap;
  width: 100%;
  .pre-defined-row {
    button {
      border: 1px solid #35373d;
      @media (max-width: 976px) {
        font-size: 13px;
      }
    }
  }
`;

const PreDefSpan = styled.span`
  width: 100%;
  // text-align: right;
  color: ${(theme) => theme.theme.Light1};
  font-size: 14px;
  margin-bottom: 12px;
`;

const PreDefinedBalances: FC<OwnProps> = ({
  onSelectBalance,
  isUserInputActive = true,
}) => {
  const [btnval, setBtnVal] = useState(0);
  const {t, i18n} = useTranslation();

  const handleBtnPrice = (val: any) => {
    onSelectBalance(val);
    setBtnVal(val / 1000000);
  };

  useEffect(() => {
    if (isUserInputActive) {
      setBtnVal(0);
    }
  }, [isUserInputActive]);

  return (
    <PreDefBalanceWrapper>
      <PreDefSpan style={{ textAlign: i18n.dir() === 'rtl' ? 'right' : 'left' }}>{t("deposit.preDef.title")}</PreDefSpan>
      <div className="w-100 d-flex justify-content-between pre-defined-row">
        <Button
          id="225"
          width={"32%"}
          color={btnval === 1 ? "Light1" : "Light2"}
          onClick={() => handleBtnPrice(100000000)}
          primary={true}
          backgroundColor={btnval === 1 ? "bgPrimaryLight" : "transparent"}
          text={t("deposit.preDef.btn1")}
        />
        <Button
          id="226"
          width={"32%"}
          color={btnval === 3 ? "Light1" : "Light2"}
          onClick={() => handleBtnPrice(300000000)}
          primary={true}
          backgroundColor={btnval === 3 ? "bgPrimaryLight" : "transparent"}
          text={t("deposit.preDef.btn2")}
        />
        <Button
          id="227"
          width={"32%"}
          color={btnval === 5 ? "Light1" : "Light2"}
          onClick={() => handleBtnPrice(500000000)}
          primary={true}
          backgroundColor={btnval === 5 ? "bgPrimaryLight" : "transparent"}
          text={t("deposit.preDef.btn3")}
        />
      </div>
    </PreDefBalanceWrapper>
  );
};

export default PreDefinedBalances;
